import { useMutation } from '@tanstack/react-query';
import { publishedUserApi } from '@/shared/api/sets/publish/pub-user';

// 발행함 - 회원정보 등록
const useRegisterUser = () =>
    useMutation({
        mutationKey: ['publish', 'registerUser'],
        mutationFn: (param: API.IntegPubUser.Req) => publishedUserApi.postIntegPubUser(param),
    });

export const publishUserQueries = {
    postRegisterUser: useRegisterUser,
};
